import React from 'react';
import { colors } from '../../styles/colors';
import { BaseIcon } from '../base/BaseIcon';
import type { EvoCreditIconProps } from './types';

export const EvoCreditSIcon = React.memo<EvoCreditIconProps>(
  ({
    className = '',
    size = 24,
    width,
    height,
    color = colors.gtred[500],
    onClick,
    title = 'EvoCredit',
    'aria-hidden': ariaHidden = false,
  }) => {
    const clipPathId = `evocredit-s-${React.useId()}`;

    return (
      <BaseIcon
        className={className}
        size={size}
        width={width}
        height={height}
        color={color}
        onClick={onClick}
        viewBox="0 0 24 24"
        aria-hidden={ariaHidden}
      >
        {!ariaHidden && title && <title>{title}</title>}
        <defs>
          <clipPath id={clipPathId}>
            <rect width="24" height="24" fill="none" />
          </clipPath>
        </defs>
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M23.815,12.364l-1.767-6.592c-.499-1.865-1.959-3.323-3.826-3.823L11.631.184c-1.865-.5-3.857.035-5.223,1.402L1.582,6.411C.217,7.776-.316,9.769.185,11.636l1.767,6.592c.499,1.865,1.959,3.323,3.825,3.823l6.592,1.766c1.865.5,3.857-.035,5.223-1.402l4.825-4.826c1.365-1.365,1.898-3.358,1.398-5.224h0ZM18.471,13.086h-9.164c.198.684.627,1.36,1.195,1.735.565.373,1.29.562,2.153.562.616,0,1.165-.094,1.63-.28.434-.173.863-.445,1.276-.809l2.094,2.094c-1.25,1.329-2.868,2.101-5.119,2.111-1.394,0-2.639-.282-3.7-.838s-1.891-1.337-2.467-2.323c-.576-.987-.868-2.114-.868-3.35s.288-2.36.857-3.339c.569-.98,1.364-1.758,2.361-2.312.997-.556,2.129-.836,3.363-.836,2.584-.05,4.498,1.222,5.538,3.149.525.974.826,2.114.874,3.339.014.359.009.725-.021,1.097h-.002Z"
            fill={color}
          />
          <path
            d="M9.249,10.892h5.712c-.286-3.253-5.426-3.254-5.712,0Z"
            fill={color}
          />
        </g>
      </BaseIcon>
    );
  },
);

EvoCreditSIcon.displayName = 'EvoCreditSIcon';
